import { render, staticRenderFns } from "./collapseAdmin.vue?vue&type=template&id=1de81c68&scoped=true&"
import script from "./collapseAdmin.vue?vue&type=script&lang=js&"
export * from "./collapseAdmin.vue?vue&type=script&lang=js&"
import style0 from "./collapseAdmin.vue?vue&type=style&index=0&id=1de81c68&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de81c68",
  null
  
)

export default component.exports